import { logger } from "./logger"

export async function measurePromiseTiming<T>(id: string, promise: Promise<T>): Promise<T> {
  if (process.env.NEXT_PUBLIC_MEASURE_PROMISE_TIMING !== "true") {
    return promise
  }

  const start = new Date()

  return promise.then((...args) => {
    const stop = new Date()
    const duration = stop.valueOf() - start.valueOf()

    logger.info(`Promise '${id}' lasted ${duration}ms.`)

    return Promise.resolve(...args)
  })
}
